// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"aba9bae3","88":"4914744b","290":"4fb25866","319":"1b4d1c30","487":"fdea5c7d","615":"49e45643","722":"e719e348","784":"0aeff787","789":"d6a23ccb","846":"8ab80d33","857":"bd509192","923":"38b265c9","944":"808d9f96"}[chunkId] + ".chunk.js";
};